// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Field details — Water Potential graph with chip filters
   ------------------------------------------------------- */
.field-details-wp {
  /* Header (40) + frame (chart 398 + legend 76) = 514. */
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 514px;
  padding: 0;
  gap: 0;
  box-sizing: border-box;
  background: transparent;
  flex: none;
}

/* Fluid height — used by the Field View where the surrounding tile
   height isn't fixed. The header keeps its 40 px row, the legend keeps
   its 76 px row, and the chart frame stretches to fill what's left.
   Farm View leaves this modifier off so the original 514 px layout
   applies. */
.field-details-wp--fluid {
  height: 100%;
  flex: 1 1 auto;
  /* Field View hosts the drop / accumulated / temperature icons next
     to the title — give the header some breathing room before the
     gray graph frame. Farm View has no toggle and keeps gap: 0. */
  gap: 10px;
}

/* Field View — visually shift the title and date chips down 8 px
   while leaving the drop / accumulated / temperature toggle at its
   natural position. The gray frame is unaffected since these are
   transforms, not layout changes. */
.field-details-wp--fluid .field-details-wp__title,
.field-details-wp--fluid .field-details-wp__date-chips {
  transform: translateY(8px);
}

/* Accumulated and Temperature graphs — same shell as the WP graph,
   but the chart itself has no event tray below the plot, so we can
   pull the gray frame up to remove the empty band the tray would
   occupy. */
.field-details-wp--accumulated.field-details-wp--fluid {
  gap: 5px;
}

.field-details-wp--temperature.field-details-wp--fluid {
  gap: 9px;
}

/* Lift the drop / accumulated / temperature toggle on the
   accumulated graph so the icons line up flush with the title. */
.field-details-wp--accumulated .field-details-wp__toggle {
  transform: translateY(-5px);
}

/* Temperature graph — keep the toggle at its natural position. */
.field-details-wp--temperature .field-details-wp__toggle {
  transform: translateY(0);
}

/* Pull the title up 6 px on the accumulated graph (overrides the
   shared 8 px translate from the fluid rule). The temperature graph
   keeps the shared 8 px translate so its title sits 6 px lower. */
.field-details-wp--accumulated.field-details-wp--fluid
  .field-details-wp__title {
  transform: translateY(2px);
}

.field-details-wp__empty {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 24px;
  color: #919db4;
  color: var(--color-grey-71, #919db4);
  font-family: 'Source Sans Pro', sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
}

/* Header sits ABOVE the gray frame: title left, date range chips right */
.field-details-wp__header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 40px;
  padding: 0;
  flex: none;
  background: transparent;
}

.field-details-wp__title-group {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  flex: none;
}

.field-details-wp__toggle {
  display: flex;
  align-items: center;
  flex: none;
}

.field-details-wp__title {
  font-family: 'Source Sans Pro', sans-serif;
  font-weight: 700;
  font-size: 16px;
  line-height: 16px;
  color: #4d5674;
  color: var(--color-grey-45, #4d5674);
}

.field-details-wp__date-chips {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0;
  flex: none;
}

.field-details-wp__date-chip {
  min-width: 40px;
  height: 24px;
  padding: 4px 8px;
  border: none;
  border-radius: 12px;
  background: transparent;
  color: #4d5674;
  color: var(--color-grey-45, #4d5674);
  font-family: 'Source Sans Pro', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  cursor: pointer;
  transition:
    background-color 0.15s ease,
    color 0.15s ease;
}

.field-details-wp__date-chip:hover:not(.field-details-wp__date-chip--selected) {
  background: #eef1f6;
  background: var(--color-grey-96, #eef1f6);
  border-radius: 8px;
}

.field-details-wp__date-chip--selected {
  background: #4d5674;
  background: var(--color-grey-45, #4d5674);
  color: #ffffff;
  border-radius: 8px;
}

/* Gray frame wraps chart + sensor legend, with a thin outline.
   Figma: 501 x 470 (gray fill, 8px radius, 1px border). */
.field-details-wp__frame {
  display: flex;
  flex-direction: column;
  background: #f6f8fa;
  background: var(--color-grey-98, #f6f8fa);
  border: 1px solid #dce0e8;
  border: 1px solid var(--color-grey-91, #dce0e8);
  border-radius: 8px;
  overflow: hidden;
  flex: 1;
  height: 474px;
}

.field-details-wp--fluid .field-details-wp__frame {
  /* Stretch to fill the remaining vertical space (parent height minus
     the 40 px header). */
  height: auto;
  min-height: 0;
}

/* Chart body — Figma 501 x 398. Legend below takes the remaining 72px. */
.field-details-wp__chart {
  height: 398px;
  flex: none;
  position: relative;
  background: #f6f8fa;
  background: var(--color-grey-98, #f6f8fa);
}

.field-details-wp--fluid .field-details-wp__chart {
  /* Take all the space the legend doesn't claim. */
  flex: 1 1 auto;
  height: auto;
  min-height: 0;
}

/* Bottom legend: "Select sensors" + chips row, gray background to match
   frame. Tighter top (closer to the divider line above), bigger
   bottom (more room between chips and frame edge). \`gap\` matches the
   Figma legend wrap (8 px) for breathing room between the label and
   the chips. */
.field-details-wp__legend {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 10px 8px 18px 8px;
  height: 76px;
  flex: none;
  background: #f6f8fa;
  background: var(--color-grey-98, #f6f8fa);
  border-top: 1px solid #dce0e8;
  border-top: 1px solid var(--color-grey-91, #dce0e8);
  box-sizing: border-box;
}

.field-details-wp__legend-label {
  font-family: 'Source Sans Pro', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: #4d5674;
  color: var(--color-grey-45, #4d5674);
}

.field-details-wp__sensor-chips {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;
  flex-wrap: wrap;
}

.field-details-wp__sensor-chip {
  height: 24px;
  padding: 4px 12px;
  border: 1px solid #919db4;
  border: 1px solid var(--color-grey-71, #919db4);
  border-radius: 12px;
  background: transparent;
  font-family: 'Source Sans Pro', sans-serif;
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  cursor: pointer;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

/* Loading spinner inside a sensor chip while its samples fetch is in
   flight. Border color inherits from the chip's currentColor so it
   matches the sensor's assigned hue. */
.field-details-wp__sensor-chip-spinner {
  display: inline-block;
  width: 12px;
  height: 12px;
  border: 2px solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: field-details-wp__sensor-chip-spin 0.7s linear infinite;
  flex: none;
}

@keyframes field-details-wp__sensor-chip-spin {
  to {
    transform: rotate(360deg);
  }
}

/* ---------------------------------------------------------------
   "Graphs" layout — Field details tab in Farm View.
   Header = [ "Graphs" title | icon tabs (centered) | range select ].
   Wide: date range as inline pills; at <= 780px tab width it collapses to
   a dropdown (container queries on .field-details-tab at the end of this
   section). The icon tabs stay centered at every width.
   --------------------------------------------------------------- */
.field-details-wp.field-details-wp--graphs {
  /* Figma: 32px header + 480px gray frame (+3px underline gap below). */
  height: 515px;
  flex: none;
  /* No flex gap: the Accumulated graph renders an extra (empty) tooltip host
     as the first child, and a gap would push its header down vs. the WP
     graph. The spacing lives on the header instead. */
  gap: 0;
}

/* Chart title inside the frame (Figma: Regular 16 / 16, grey-45) */
.field-details-wp__chart-title {
  display: none;
}

.field-details-wp--graphs .field-details-wp__chart-title {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  flex: none;
  padding: 16px 16px 0;
  font-family: 'Source Sans Pro', sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 16px;
  color: var(--color-grey-45);
  color: var(--color-grey-45);
}

/* Legend: 80px, padding 16/0/8/0 */
.field-details-wp--graphs .field-details-wp__legend {
  height: 80px;
  padding: 16px 0 8px;
}

.field-details-wp--graphs .field-details-wp__header {
  display: grid;
  /* minmax(0, 1fr): equal side columns whatever their content (range
     pills, native select, "Select graphs" dropdown), so the icon tabs stay
     centered when switching graphs. */
  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);
  align-items: end;
  -moz-column-gap: 16px;
       column-gap: 16px;
  height: auto;
  min-height: 32px;
  /* Underline overhang of the icon tabs (GraphToggle has a -3px bottom
     margin), so the underline sits flush on the frame. */
  margin-bottom: 3px;
}

/* Let the title and the icon tabs be direct grid items of the header. */
.field-details-wp--graphs .field-details-wp__title-group {
  display: contents;
}

.field-details-wp.field-details-wp--graphs .field-details-wp__title {
  grid-column: 1;
  grid-row: 1;
  justify-self: start;
  align-self: end;
  transform: none;
  /* Figma title wrap: 24px tall = 16px label + 8px bottom padding */
  height: 24px;
  box-sizing: border-box;
  padding-bottom: 8px;
}

.field-details-wp--graphs .field-details-wp__toggle {
  grid-column: 2;
  grid-row: 1;
  justify-self: center;
  /* GraphToggle's buttons are 26px tall but hold 24 + 5 + 3px of content, so
     the active underline hangs ~8px below the toggle box (5px past the frame
     top with the 3px header gap). -7px lands the underline flush on the
     frame instead of overlapping it. */
  transform: translateY(-7px);
}

.field-details-wp--graphs .field-details-wp__date-chips,
.field-details-wp--graphs .field-details-wp__header > .dropdown {
  grid-column: 3;
  grid-row: 1;
  justify-self: end;
  align-self: end;
  transform: none !important;
  margin-bottom: 6px;
}

.field-details-wp--graphs .field-details-wp__frame {
  height: auto;
  min-height: 0;
}

.field-details-wp--graphs .field-details-wp__chart {
  height: auto;
  flex: 1 1 auto;
  min-height: 0;
}

/* Range dropdown is only used when the tab is narrow (see below). Raised
   above the chart frame so the open menu isn't hidden behind it. */
.field-details-wp__range-dropdown {
  display: none;
  position: relative;
  z-index: 10;
}

@container field-details-tab (max-width: 520px) {
  .field-details-wp.field-details-wp--graphs {
    /* Figma: 32px header + 488px gray frame (+3px underline gap). */
    height: 523px;
  }
}

/* The full pill row (7 x 40px) needs ~282px on each side of the centered
   icon tabs; below that the pills would run into the tabs, so collapse to
   the dropdown before the Figma "small" breakpoint. */
@container field-details-tab (max-width: 780px) {
  .field-details-wp--graphs .field-details-wp__date-chips {
    display: none;
  }

  .field-details-wp--graphs .field-details-wp__range-dropdown {
    display: block;
  }
}
`, "",{"version":3,"sources":["webpack://./app/components/dashboard/AllFarmView/FieldDetailsWPGraph.css"],"names":[],"mappings":"AAAA;4DAC4D;AAC5D;EACE,uDAAuD;EACvD,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,UAAU;EACV,MAAM;EACN,sBAAsB;EACtB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;;;;aAIa;AACb;EACE,YAAY;EACZ,cAAc;EACd;;kEAEgE;EAChE,SAAS;AACX;;AAEA;;;oCAGoC;AACpC;;EAEE,0BAA0B;AAC5B;;AAEA;;;YAGY;AACZ;EACE,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;AAEA;iEACiE;AACjE;EACE,2BAA2B;AAC7B;;AAEA,iEAAiE;AACjE;EACE,wBAAwB;AAC1B;;AAEA;;kEAEkE;AAClE;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,oCAAoC;EACpC,0CAA0C;EAC1C,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA,yEAAyE;AACzE;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,UAAU;EACV,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,0CAA0C;EAC1C,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,oCAAoC;EACpC,0CAA0C;EAC1C,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf;;oBAEkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,yCAAyC;EACzC,cAAc;EACd,kBAAkB;AACpB;;AAEA;0DAC0D;AAC1D;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,yCAAyC;EACzC,yBAAyB;EACzB,+CAA+C;EAC/C,kBAAkB;EAClB,gBAAgB;EAChB,OAAO;EACP,aAAa;AACf;;AAEA;EACE;yBACuB;EACvB,YAAY;EACZ,aAAa;AACf;;AAEA,yEAAyE;AACzE;EACE,aAAa;EACb,UAAU;EACV,kBAAkB;EAClB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,iDAAiD;EACjD,cAAc;EACd,YAAY;EACZ,aAAa;AACf;;AAEA;;;;eAIe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,0BAA0B;EAC1B,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,yCAAyC;EACzC,6BAA6B;EAC7B,mDAAmD;EACnD,sBAAsB;AACxB;;AAEA;EACE,0CAA0C;EAC1C,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,+CAA+C;EAC/C,mBAAmB;EACnB,uBAAuB;EACvB,0CAA0C;EAC1C,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;uCAEuC;AACvC;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,+BAA+B;EAC/B,kBAAkB;EAClB,kEAAkE;EAClE,UAAU;AACZ;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;;;;;;oEAMoE;AACpE;EACE,sEAAsE;EACtE,aAAa;EACb,UAAU;EACV;;sDAEoD;EACpD,MAAM;AACR;;AAEA,mEAAmE;AACnE;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,UAAU;EACV,oBAAoB;EACpB,0CAA0C;EAC1C,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA,mCAAmC;AACnC;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb;;sCAEoC;EACpC,yDAAyD;EACzD,gBAAgB;EAChB,qBAAqB;OAChB,gBAAgB;EACrB,YAAY;EACZ,gBAAgB;EAChB;yDACuD;EACvD,kBAAkB;AACpB;;AAEA,wEAAwE;AACxE;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,kEAAkE;EAClE,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,oBAAoB;EACpB;;;uCAGqC;EACrC,2BAA2B;AAC7B;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,aAAa;AACf;;AAEA;mEACmE;AACnE;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE;IACE,gEAAgE;IAChE,aAAa;EACf;AACF;;AAEA;;sDAEsD;AACtD;EACE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":["/* Field details — Water Potential graph with chip filters\n   ------------------------------------------------------- */\n.field-details-wp {\n  /* Header (40) + frame (chart 398 + legend 76) = 514. */\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 514px;\n  padding: 0;\n  gap: 0;\n  box-sizing: border-box;\n  background: transparent;\n  flex: none;\n}\n\n/* Fluid height — used by the Field View where the surrounding tile\n   height isn't fixed. The header keeps its 40 px row, the legend keeps\n   its 76 px row, and the chart frame stretches to fill what's left.\n   Farm View leaves this modifier off so the original 514 px layout\n   applies. */\n.field-details-wp--fluid {\n  height: 100%;\n  flex: 1 1 auto;\n  /* Field View hosts the drop / accumulated / temperature icons next\n     to the title — give the header some breathing room before the\n     gray graph frame. Farm View has no toggle and keeps gap: 0. */\n  gap: 10px;\n}\n\n/* Field View — visually shift the title and date chips down 8 px\n   while leaving the drop / accumulated / temperature toggle at its\n   natural position. The gray frame is unaffected since these are\n   transforms, not layout changes. */\n.field-details-wp--fluid .field-details-wp__title,\n.field-details-wp--fluid .field-details-wp__date-chips {\n  transform: translateY(8px);\n}\n\n/* Accumulated and Temperature graphs — same shell as the WP graph,\n   but the chart itself has no event tray below the plot, so we can\n   pull the gray frame up to remove the empty band the tray would\n   occupy. */\n.field-details-wp--accumulated.field-details-wp--fluid {\n  gap: 5px;\n}\n\n.field-details-wp--temperature.field-details-wp--fluid {\n  gap: 9px;\n}\n\n/* Lift the drop / accumulated / temperature toggle on the\n   accumulated graph so the icons line up flush with the title. */\n.field-details-wp--accumulated .field-details-wp__toggle {\n  transform: translateY(-5px);\n}\n\n/* Temperature graph — keep the toggle at its natural position. */\n.field-details-wp--temperature .field-details-wp__toggle {\n  transform: translateY(0);\n}\n\n/* Pull the title up 6 px on the accumulated graph (overrides the\n   shared 8 px translate from the fluid rule). The temperature graph\n   keeps the shared 8 px translate so its title sits 6 px lower. */\n.field-details-wp--accumulated.field-details-wp--fluid\n  .field-details-wp__title {\n  transform: translateY(2px);\n}\n\n.field-details-wp__empty {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  padding: 24px;\n  color: #919db4;\n  color: var(--color-grey-71, #919db4);\n  font-family: 'Source Sans Pro', sans-serif;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n/* Header sits ABOVE the gray frame: title left, date range chips right */\n.field-details-wp__header {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  height: 40px;\n  padding: 0;\n  flex: none;\n  background: transparent;\n}\n\n.field-details-wp__title-group {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 12px;\n  flex: none;\n}\n\n.field-details-wp__toggle {\n  display: flex;\n  align-items: center;\n  flex: none;\n}\n\n.field-details-wp__title {\n  font-family: 'Source Sans Pro', sans-serif;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 16px;\n  color: #4d5674;\n  color: var(--color-grey-45, #4d5674);\n}\n\n.field-details-wp__date-chips {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 0;\n  flex: none;\n}\n\n.field-details-wp__date-chip {\n  min-width: 40px;\n  height: 24px;\n  padding: 4px 8px;\n  border: none;\n  border-radius: 12px;\n  background: transparent;\n  color: #4d5674;\n  color: var(--color-grey-45, #4d5674);\n  font-family: 'Source Sans Pro', sans-serif;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 16px;\n  cursor: pointer;\n  transition:\n    background-color 0.15s ease,\n    color 0.15s ease;\n}\n\n.field-details-wp__date-chip:hover:not(.field-details-wp__date-chip--selected) {\n  background: #eef1f6;\n  background: var(--color-grey-96, #eef1f6);\n  border-radius: 8px;\n}\n\n.field-details-wp__date-chip--selected {\n  background: #4d5674;\n  background: var(--color-grey-45, #4d5674);\n  color: #ffffff;\n  border-radius: 8px;\n}\n\n/* Gray frame wraps chart + sensor legend, with a thin outline.\n   Figma: 501 x 470 (gray fill, 8px radius, 1px border). */\n.field-details-wp__frame {\n  display: flex;\n  flex-direction: column;\n  background: #f6f8fa;\n  background: var(--color-grey-98, #f6f8fa);\n  border: 1px solid #dce0e8;\n  border: 1px solid var(--color-grey-91, #dce0e8);\n  border-radius: 8px;\n  overflow: hidden;\n  flex: 1;\n  height: 474px;\n}\n\n.field-details-wp--fluid .field-details-wp__frame {\n  /* Stretch to fill the remaining vertical space (parent height minus\n     the 40 px header). */\n  height: auto;\n  min-height: 0;\n}\n\n/* Chart body — Figma 501 x 398. Legend below takes the remaining 72px. */\n.field-details-wp__chart {\n  height: 398px;\n  flex: none;\n  position: relative;\n  background: #f6f8fa;\n  background: var(--color-grey-98, #f6f8fa);\n}\n\n.field-details-wp--fluid .field-details-wp__chart {\n  /* Take all the space the legend doesn't claim. */\n  flex: 1 1 auto;\n  height: auto;\n  min-height: 0;\n}\n\n/* Bottom legend: \"Select sensors\" + chips row, gray background to match\n   frame. Tighter top (closer to the divider line above), bigger\n   bottom (more room between chips and frame edge). `gap` matches the\n   Figma legend wrap (8 px) for breathing room between the label and\n   the chips. */\n.field-details-wp__legend {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 8px 18px 8px;\n  height: 76px;\n  flex: none;\n  background: #f6f8fa;\n  background: var(--color-grey-98, #f6f8fa);\n  border-top: 1px solid #dce0e8;\n  border-top: 1px solid var(--color-grey-91, #dce0e8);\n  box-sizing: border-box;\n}\n\n.field-details-wp__legend-label {\n  font-family: 'Source Sans Pro', sans-serif;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 16px;\n  color: #4d5674;\n  color: var(--color-grey-45, #4d5674);\n}\n\n.field-details-wp__sensor-chips {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.field-details-wp__sensor-chip {\n  height: 24px;\n  padding: 4px 12px;\n  border: 1px solid #919db4;\n  border: 1px solid var(--color-grey-71, #919db4);\n  border-radius: 12px;\n  background: transparent;\n  font-family: 'Source Sans Pro', sans-serif;\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 16px;\n  cursor: pointer;\n  white-space: nowrap;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n/* Loading spinner inside a sensor chip while its samples fetch is in\n   flight. Border color inherits from the chip's currentColor so it\n   matches the sensor's assigned hue. */\n.field-details-wp__sensor-chip-spinner {\n  display: inline-block;\n  width: 12px;\n  height: 12px;\n  border: 2px solid currentColor;\n  border-right-color: transparent;\n  border-radius: 50%;\n  animation: field-details-wp__sensor-chip-spin 0.7s linear infinite;\n  flex: none;\n}\n\n@keyframes field-details-wp__sensor-chip-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* ---------------------------------------------------------------\n   \"Graphs\" layout — Field details tab in Farm View.\n   Header = [ \"Graphs\" title | icon tabs (centered) | range select ].\n   Wide: date range as inline pills; at <= 780px tab width it collapses to\n   a dropdown (container queries on .field-details-tab at the end of this\n   section). The icon tabs stay centered at every width.\n   --------------------------------------------------------------- */\n.field-details-wp.field-details-wp--graphs {\n  /* Figma: 32px header + 480px gray frame (+3px underline gap below). */\n  height: 515px;\n  flex: none;\n  /* No flex gap: the Accumulated graph renders an extra (empty) tooltip host\n     as the first child, and a gap would push its header down vs. the WP\n     graph. The spacing lives on the header instead. */\n  gap: 0;\n}\n\n/* Chart title inside the frame (Figma: Regular 16 / 16, grey-45) */\n.field-details-wp__chart-title {\n  display: none;\n}\n\n.field-details-wp--graphs .field-details-wp__chart-title {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  flex: none;\n  padding: 16px 16px 0;\n  font-family: 'Source Sans Pro', sans-serif;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 16px;\n  color: var(--color-grey-45);\n  color: var(--color-grey-45);\n}\n\n/* Legend: 80px, padding 16/0/8/0 */\n.field-details-wp--graphs .field-details-wp__legend {\n  height: 80px;\n  padding: 16px 0 8px;\n}\n\n.field-details-wp--graphs .field-details-wp__header {\n  display: grid;\n  /* minmax(0, 1fr): equal side columns whatever their content (range\n     pills, native select, \"Select graphs\" dropdown), so the icon tabs stay\n     centered when switching graphs. */\n  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);\n  align-items: end;\n  -moz-column-gap: 16px;\n       column-gap: 16px;\n  height: auto;\n  min-height: 32px;\n  /* Underline overhang of the icon tabs (GraphToggle has a -3px bottom\n     margin), so the underline sits flush on the frame. */\n  margin-bottom: 3px;\n}\n\n/* Let the title and the icon tabs be direct grid items of the header. */\n.field-details-wp--graphs .field-details-wp__title-group {\n  display: contents;\n}\n\n.field-details-wp.field-details-wp--graphs .field-details-wp__title {\n  grid-column: 1;\n  grid-row: 1;\n  justify-self: start;\n  align-self: end;\n  transform: none;\n  /* Figma title wrap: 24px tall = 16px label + 8px bottom padding */\n  height: 24px;\n  box-sizing: border-box;\n  padding-bottom: 8px;\n}\n\n.field-details-wp--graphs .field-details-wp__toggle {\n  grid-column: 2;\n  grid-row: 1;\n  justify-self: center;\n  /* GraphToggle's buttons are 26px tall but hold 24 + 5 + 3px of content, so\n     the active underline hangs ~8px below the toggle box (5px past the frame\n     top with the 3px header gap). -7px lands the underline flush on the\n     frame instead of overlapping it. */\n  transform: translateY(-7px);\n}\n\n.field-details-wp--graphs .field-details-wp__date-chips,\n.field-details-wp--graphs .field-details-wp__header > .dropdown {\n  grid-column: 3;\n  grid-row: 1;\n  justify-self: end;\n  align-self: end;\n  transform: none !important;\n  margin-bottom: 6px;\n}\n\n.field-details-wp--graphs .field-details-wp__frame {\n  height: auto;\n  min-height: 0;\n}\n\n.field-details-wp--graphs .field-details-wp__chart {\n  height: auto;\n  flex: 1 1 auto;\n  min-height: 0;\n}\n\n/* Range dropdown is only used when the tab is narrow (see below). Raised\n   above the chart frame so the open menu isn't hidden behind it. */\n.field-details-wp__range-dropdown {\n  display: none;\n  position: relative;\n  z-index: 10;\n}\n\n@container field-details-tab (max-width: 520px) {\n  .field-details-wp.field-details-wp--graphs {\n    /* Figma: 32px header + 488px gray frame (+3px underline gap). */\n    height: 523px;\n  }\n}\n\n/* The full pill row (7 x 40px) needs ~282px on each side of the centered\n   icon tabs; below that the pills would run into the tabs, so collapse to\n   the dropdown before the Figma \"small\" breakpoint. */\n@container field-details-tab (max-width: 780px) {\n  .field-details-wp--graphs .field-details-wp__date-chips {\n    display: none;\n  }\n\n  .field-details-wp--graphs .field-details-wp__range-dropdown {\n    display: block;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
